import { render, staticRenderFns } from "./Unassigned.vue?vue&type=template&id=606fde8e&"
import script from "./Unassigned.vue?vue&type=script&lang=js&"
export * from "./Unassigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports